import Types from '../Types';

const attemptFindCompanies = (payload) => ({
  type: Types.FIND_COMPANIES_ATTEMPT, payload
});
const attemptFindCompanyOptions = () => ({
  type: Types.FIND_COMPANY_OPTIONS_ATTEMPT, payload: { selector: true }
});

export default {
  attemptFindCompanies,
  attemptFindCompanyOptions
};



/** WEBPACK FOOTER **
 ** ./src/redux/company/companyActions.js
 **/